import { useMutation, useQueryClient, useQuery } from "@tanstack/react-query";
import { api } from "../../../../Services/Api/createApi";
// import { request } from "@/core/utils/axios"

// @POST
const subscribeToSectionMutationFun = (payload) => {
  return api({
    url: "/subscribe_to_section",
    method: "POST",
    data: payload,
    // headers: { "Content-Type": "multipart/form-data" },
  });
};

// @GET
const getSectionQuiz = ({ sessionId }) => {
  return api({ url: `get_section_quize?id=${sessionId}` });
};

// ===================[Query & Mutation Hooks]===================

// @Mutation
export const useSubscribeToSectionMutation = () => {
  return useMutation({
    mutationFn: subscribeToSectionMutationFun,
  });
};

//@Query
export const useGetSectionQuiz = ({ sessionId }) => {
  return useQuery({
    queryKey: ["get-section-quiz", sessionId],
    queryFn: () => getSectionQuiz({ sessionId }),
    select: (data) => data?.data?.data,
  });
};
